export type PriceBookResolutionErrorKind = 'missing-version' | 'unresolved-records';

export type PriceBookResolutionErrorParams = {
	kind: PriceBookResolutionErrorKind;
	message: string;
	versionId?: string | null;
	versionName?: string | null;
	unresolvedSkus?: Array<string>;
};

/**
 * Thrown when a design cannot be priced against its resolved price book: the pinned version is
 * absent from this database, or the estimate carries rows the version holds no record for.
 */
export class PriceBookResolutionError extends Error {
	readonly kind: PriceBookResolutionErrorKind;
	readonly versionId: string | null;
	readonly versionName: string | null;
	readonly unresolvedSkus: Array<string>;

	constructor (params: PriceBookResolutionErrorParams) {
		const { kind, versionId = null, versionName = null, unresolvedSkus = [], message } = params;
		super(message);

		this.name = 'PriceBookResolutionError';
		this.kind = kind;
		this.versionId = versionId;
		this.versionName = versionName;
		this.unresolvedSkus = unresolvedSkus;
	}
}
